import { createAction, createReducer } from "redux-act";
import produce from "immer";
import { reducerRegistry } from "../reducerRegistry";

export type MeasurerState = {
  active: boolean;
};

export const reducerName = "measurer";

const initialState: MeasurerState = {
  active: false,
};

export const toggleMeasurer = createAction<boolean>("measurer/toggle");
export const reducer = createReducer({}, initialState);

reducer.on(
  toggleMeasurer,
  produce((measurerState: MeasurerState, active: boolean) => {
    measurerState.active = active;
  }),
);

reducerRegistry.register(reducerName, reducer);
